var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M19.87 5.312c0-1.757-1.293-3.171-2.89-3.171A141.078 141.078 0 0 0 10.352 2H9.65c-2.25 0-4.462.04-6.626.14C1.43 2.14.137 3.563.137 5.32A57.22 57.22 0 0 0 0 9.492c-.004 1.39.04 2.78.133 4.175 0 1.758 1.293 3.184 2.887 3.184 2.274.105 4.606.152 6.978.148 2.375.008 4.7-.039 6.977-.148 1.598 0 2.891-1.426 2.891-3.184a59.52 59.52 0 0 0 .133-4.18 57.384 57.384 0 0 0-.129-4.175zM8.087 13.324V5.648l5.665 3.836-5.665 3.84z"}));
}

YoutubeInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
